import styled from 'styled-components';

export const FileUploadContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  padding-bottom: 10px;
`;

export const UploadBox = styled.div``;
